import { createFileRoute } from '@tanstack/react-router'

import { StaffSettingsPage } from '@/features/settings/section-pages'

export const Route = createFileRoute('/_app/settings/staff')({
  component: StaffSettingsPage,
})
